
import pubsub from "@viewlift/pubsub"
const publishVerticalMastheadStatus = (data) => {
    pubsub.publish('enable-vertical-navigation', data)
}
const subscribeVerticalMastheadStatus = (cb) => {
    pubsub.subscribe('enable-vertical-navigation', cb)
}
export {publishVerticalMastheadStatus, subscribeVerticalMastheadStatus}